/**
 * author: Qian.qianchen
 * time: 2019-01-21
 */
'use strict';
angular.module("settingSentimentModule", [])
    .controller("settingSentimentCtrl", ["$scope", "$timeout", "$modalInstance", "trsHttpService", "modalDialog", "nav", "$q", "$validation", "localStorageService", function($scope, $timeout, $modalInstance, trsHttpService, modalDialog, nav, $q, $validation, localStorageService) {
        initStatus();
        initData();
        $scope.$watch('data.customInfo', function(newVal, oldVal) {
            // console.log(newVal);
        });
        $scope.$watch('data.mediaInfo', function(newVal, oldVal) {
            // console.log(newVal);
        });
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                navSelected: nav == '' ? 'breakNav' : nav,
                tabList: [{ name: '突发舆情', value: 'breakNav' }, { name: '自定义舆情', value: 'customNav' }, { name: '社交媒体信息', value: 'mediaInfoNav' }],
                customTabSelected: {},
                getData: false,
                saveSuccess: false,
                addStatus: true
            };
            $scope.data = {
                breakData: {

                },
                customTitles: [],
                mediaInfo: {
                    keyWords: [],
                    flag: true
                },
                customObj: {
                    title: '',
                    includeKeyword: [],
                    exclusiveKeyword: [],
                    area: ''
                },
                customInfo: [],
                territoryData: []
            }
            $scope.breakForm = {}
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            getAreaData();
            geCustomTitle();
            requestData();
        }
        /**
         * [getAreaData description] 获取地域数据
         * @return {[type]} [description]
         */
        function getAreaData() {
            var defer = $q.defer();
            var params = {
                'modelid': 'getallarea',
                'serviceid': 'customsentiment'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                $scope.data.territoryData = data;
                defer.resolve();
            });
            return defer.promise;
        }

        function geCustomTitle() {
            var defer = $q.defer();
            var params = {
                'modelid': 'gettitles',
                'serviceid': 'customsentiment'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                $scope.data.customTitles = data;
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [requestData description] 数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            var type = '1';
            if ($scope.status.navSelected == 'customNav') {
                type = '2';
            } else if ($scope.status.navSelected == 'mediaInfoNav') {
                type = '3';
            }
            var params = {
                'modelid': 'getrule',
                'serviceid': 'customsentiment',
                'type': type,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                if (type == '1') {
                    Object.keys(data).forEach(function(key) {
                        $scope.data.breakData = data[key];
                    });
                    localStorageService.set('breakData', $scope.data.breakData);
                } else if (type == '2') {
                    if (Object.getOwnPropertyNames(data).length == 0) {
                        $scope.data.customInfo = [{
                            id: 0,
                            title: '',
                            includeKeyword: [],
                            exclusiveKeyword: [],
                            area: '',
                        }];
                    } else {
                        $scope.data.customInfo = [];
                        Object.keys(data).forEach(function(key) {
                            data[key].includeKeyword = data[key].includeKeyword == '' ? [] : data[key].includeKeyword.split(';');
                            data[key].exclusiveKeyword = data[key].exclusiveKeyword == '' ? [] : data[key].exclusiveKeyword.split(';');
                            data[key].flag = true;
                            $scope.data.customInfo.push(data[key]);
                        });
                    }
                    $scope.status.customTabSelected = $scope.data.customInfo[0];
                    localStorageService.set('customData', $scope.data.customInfo);
                } else {
                    Object.keys(data).forEach(function(key) {
                        $scope.data.mediaInfo.keyWords = data[key].includeKeyword == '' ? [] : data[key].includeKeyword.split(';');
                    });
                    localStorageService.set('mediaData', $scope.data.mediaInfo);
                }
                defer.resolve();
                $scope.status.getData = true;
            });
            return defer.promise;
        }
        /**
         * [saveBreakData description] 突发舆情数据保存
         * @return {[type]} [description]
         */
        function saveBreakData() {
            var defer = $q.defer();
            $scope.breakForm.$pending = {};
            $validation.validate($scope.breakForm).success(function() {
                var params = {
                    'modelid': 'saverule',
                    'serviceid': 'customsentiment',
                    'content': $scope.data.breakData.content,
                    'type': 1
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    $scope.status.saveSuccess = true;
                    $timeout(function() {
                        $scope.status.saveSuccess = false;
                    }, 2000);
                    defer.resolve(JSON.parse(data));
                });
            });
            return defer.promise;
        }
        /**
         * [saveMediaData description] 社交媒体信息保存
         * @return {[type]} [description]
         */
        function saveMediaData() {
            var defer = $q.defer();
            var params = {
                'modelid': 'saverule',
                'serviceid': 'customsentiment',
                'keywordsinclude': $scope.data.mediaInfo.keyWords.join(';'),
                'type': 3
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                $scope.status.saveSuccess = true;
                $timeout(function() {
                    $scope.status.saveSuccess = false;
                }, 2000);
                defer.resolve(JSON.parse(data));
            });
            return defer.promise;
        }
        /**
         * [getPropertyStr description] 属性字符串拼接
         * @param  {[Array]} arr       [description] 数组
         * @param  {[String]} property  [description] 属性
         * @param  {[String]} separator [description] 分隔符
         * @return {[String]}           [description] 拼接后的字符串
         */
        function getPropertyStr(arr, property, separator) {
            var str = arr.map(function(currVal) {
                return currVal[property];
            }).join(separator);
            return str;
        }
        /**
         * [getWordsStr description] 关键词数组拼接
         * @param  {[type]} property [description] 关键词属性
         * @return {[type]}          [description]
         */
        function getWordsStr(property) {
            var keywordsStr = $scope.data.customInfo.map(function(currVal) {
                return currVal[property].map(function(keyword) {
                    return keyword;
                }).join(';');
            }).join('|');
            return keywordsStr;
        }
        /**
         * [saveCustomData description] 自定义舆情规则保存
         * @return {[type]} [description]
         */
        function saveCustomData() {
            var defer = $q.defer();
            $scope.customForm.$pending = {};
            $validation.validate($scope.customForm).success(function() {
                var params = {
                    'modelid': 'saverule',
                    'serviceid': 'customsentiment',
                    'title': getPropertyStr($scope.data.customInfo, 'title', '|'),
                    'keywordsinclude': getWordsStr('includeKeyword'),
                    'keywordsexclusive': getWordsStr('exclusiveKeyword'),
                    'area': getPropertyStr($scope.data.customInfo, 'area', '|'),
                    'id': getPropertyStr($scope.data.customInfo, 'id', '|'),
                    'type': 2
                };
                $scope.status.addStatus = false;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    $scope.status.addStatus = true;
                    $scope.status.saveSuccess = true;
                    $timeout(function() {
                        $scope.status.saveSuccess = false;
                    }, 2000);
                    defer.resolve(JSON.parse(data));
                });
            }).error(function(err) {
                for (var i = 0; i < $scope.data.customInfo.length; i++) {
                    if ($scope.data.customInfo[i].title == '') {
                        $scope.selectTab($scope.data.customInfo[i]);
                        return;
                    }
                }
            });
            return defer.promise;
        }
        /**
         * [cancel description] 弹窗关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            var currData,
                storage = 'breakData';
            if ($scope.status.navSelected == 'breakNav') {
                currData = $scope.data.breakData;
            } else if ($scope.status.navSelected == 'customNav') {
                currData = $scope.data.customInfo;
                storage = 'customData';
            } else if ($scope.status.navSelected == 'mediaInfoNav') {
                currData = $scope.data.mediaInfo;
                storage = 'mediaData';
            }
            var oldData = localStorageService.get(storage);
            if (JSON.stringify(currData) == JSON.stringify(oldData)) {
                localStorageService.remove(storage);
                $modalInstance.close(true);
            } else {
                modalDialog.alertType("", "数据还未保存，是否确认关闭？关闭后未保存数据将丢失", "ask", true, function() {
                    localStorageService.remove(storage);
                    $modalInstance.close(true);
                });
            }
        }
        /**
         * [tabClick description] 
         * @param  {[type]} tab [description]
         * @return {[type]}     [description]
         */
        $scope.tabClick = function(tab) {
            var currData,
                storage = 'breakData';
            if ($scope.status.navSelected == 'breakNav') {
                currData = $scope.data.breakData;
            } else if ($scope.status.navSelected == 'customNav') {
                currData = $scope.data.customInfo;
                storage = 'customData';
            } else if ($scope.status.navSelected == 'mediaInfoNav') {
                currData = $scope.data.mediaInfo;
                storage = 'mediaData';
            }
            var oldData = localStorageService.get(storage);
            if (JSON.stringify(currData) == JSON.stringify(oldData)) {
                localStorageService.remove(storage);
                $scope.status.getData = false;
                $scope.status.navSelected = tab.value;
                requestData();
            } else {
                modalDialog.alertType("", "数据还未保存，是否确认切换？切换后未保存数据将丢失", "ask", true, function() {
                    localStorageService.remove(storage);
                    $scope.status.getData = false;
                    $scope.status.navSelected = tab.value;
                    requestData();
                });
            }
        }
        /**
         * [selectArea description] 地域选择
         * @param  {[type]} area [description] 地域对象
         * @param  {[type]} customDetail [description] 自定义舆情规则对象
         * @return {[type]}      [description]
         */
        $scope.selectArea = function(area, customDetail) {
            var areaArr = customDetail.area == '' ? [] : customDetail.area.split(';');

            if (areaArr.indexOf(area.code) > -1 && area.code == 'all') {
                areaArr = [];
            } else if (areaArr.indexOf(area.code) < 0 && area.code == 'all') {
                areaArr = ['all'];
            } else if (areaArr.indexOf(area.code) > -1 && area.code != 'all') {
                areaArr.splice(areaArr.indexOf(area.code), 1);
            } else {
                if (areaArr[0] == 'all') {
                    areaArr = [];
                }
                areaArr.push(area.code);
            }
            customDetail.area = areaArr.join(';');
        }
        /**
         * [selectTab description] 自定义舆情规则-tab切换
         * @param  {[Object]} customTab [description] 自定义舆情规则对象
         * @return {[type]}           [description]
         */
        $scope.selectTab = function(customTab) {
            $scope.status.customTabSelected = customTab;
        }
        /**
         * [addNewCustom description] 新建
         */
        $scope.addNewCustom = function() {
            $scope.data.customInfo.push({
                id: 0,
                title: '',
                includeKeyword: [],
                exclusiveKeyword: [],
                area: ''
            });
            $scope.status.customTabSelected = $scope.data.customInfo[$scope.data.customInfo.length - 1];
        }
        /**
         * [deleteCustom description] 删除自定义舆情规则
         * @param  {[Object]} customItem [description] 自定义舆情规则对象
         * @param  {[Object]} ev         [description] event对象
         * @return {[type]}            [description]
         */
        $scope.deleteCustom = function(customItem, ev) {
            ev.stopPropagation();
            if (customItem.id != '0') {
                var params = {
                    'modelid': 'deleterule',
                    'serviceid': 'customsentiment',
                    'id': customItem.id
                };
                $scope.status.addStatus = false;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                    $scope.data.customInfo.splice($scope.data.customInfo.indexOf(customItem), 1);
                    if ($scope.status.customTabSelected == customItem) {
                        $scope.status.customTabSelected = $scope.data.customInfo[0];
                    }
                    if ($scope.data.customInfo.length == 0) {
                        $timeout(function() {
                            $scope.addNewCustom();
                            localStorageService.set('customData', $scope.data.customInfo);
                        });
                    } else {
                        $timeout(function() {
                            localStorageService.set('customData', $scope.data.customInfo);
                        });
                    }
                    $scope.status.addStatus = true;
                    $scope.status.saveSuccess = true;
                    $timeout(function() {
                        $scope.status.saveSuccess = false;
                    }, 2000);
                });
            } else {
                $scope.data.customInfo.splice($scope.data.customInfo.indexOf(customItem), 1);
                if ($scope.status.customTabSelected == customItem) {
                    $scope.status.customTabSelected = $scope.data.customInfo[0];
                }
                if ($scope.data.customInfo.length == 0) {
                    $timeout(function() {
                        $scope.addNewCustom();
                    });
                }
            }

        }
        /**
         * [submit description] 保存
         * @return {[type]} [description]
         */
        $scope.submit = function() {
            if ($scope.status.navSelected == 'breakNav') {
                saveBreakData().then(function(data) {
                    if (data == "保存成功") {
                        requestData();
                    }
                });
            } else if ($scope.status.navSelected == 'customNav') {
                saveCustomData().then(function(data) {
                    if (data == "保存成功") {
                        requestData();
                    }
                });
            } else if ($scope.status.navSelected == 'mediaInfoNav') {
                saveMediaData().then(function(data) {
                    if (data == "保存成功") {
                        requestData();
                    }
                });
            }
        }
    }]);